import { useEffect, useState } from 'react';

import { QueryDefinition } from '@reduxjs/toolkit/dist/query';
import { QueryHooks } from '@reduxjs/toolkit/dist/query/react/buildHooks';

export interface IInfiniteQuery {
    searchValue?: string;
    start?: boolean;
    from?: number;
    size?: number;
    use_search_after?: boolean;
    search_after_values?: string[] | null;
}

export function useInfiniteQuery<Data, Query extends IInfiniteQuery = IInfiniteQuery>(
    endpoint: QueryHooks<QueryDefinition<Query, any, string, Data[]>>,
) {
    const [pages, setPages] = useState<Data[]>([]);

    const [trigger, result] = endpoint.useLazyQuery();

    useEffect(() => {
        if (!result.isSuccess) return;
        setPages((pages ?? []).concat(result.data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [result.data]);

    return {
        ...result,
        data: pages,
        isLoading: result.isFetching && pages === undefined,
        hasMore: result.data?.length === 24,
        fetchNextPage(query: Query) {
            if (query.start) {
                setPages([]);
            }
            trigger({ ...query, from: query.start ? 0 : pages.length });
        },
    };
}
